import { createV3Queries } from "@query/utils/createV3Queries";
import { notificationsApi } from "@api";

export const queriesNotifications = createV3Queries(
  "notificationsApi",
  notificationsApi
);
